import React from 'react';
import {FilesViewAllContent, FilesViewAllSidebar} from './components';
import {PageLayoutTwoCol} from 'layout/components';

export const FilesViewAll = () => (
  <PageLayoutTwoCol sidebar={<FilesViewAllSidebar />} content={<FilesViewAllContent />} />
);
